import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [error, setError] = useState('');

  // 检查token是否过期
  const isTokenExpired = (token) => {
    try {
      const tokenParts = token.split('.');
      if (tokenParts.length === 3) {
        const payloadBase64 = tokenParts[1];
        const payload = JSON.parse(atob(payloadBase64));
        
        if (payload && payload.exp) {
          const currentTime = Math.floor(Date.now() / 1000);
          return currentTime >= payload.exp;
        }
      }
      return true; // 如果无法解析，认为已过期
    } catch (error) {
      console.error('Error checking token expiration:', error);
      return true;
    }
  };

  // 解析token并设置用户状态
  const parseTokenAndSetUser = (token) => {
    try {
      const tokenParts = token.split('.');
      if (tokenParts.length === 3) {
        const payloadBase64 = tokenParts[1];
        const payload = JSON.parse(atob(payloadBase64));
        
        if (payload && payload.email && !isTokenExpired(token)) {
          setIsLoggedIn(true);
          setUserEmail(payload.email);
          setIsAdmin(!!payload.isAdmin);
          console.log('Token parsed successfully, user email:', payload.email, 'isAdmin:', !!payload.isAdmin);
          return true;
        } else {
          console.error('Token payload missing or expired');
          localStorage.removeItem('token');
          setIsLoggedIn(false);
          setUserEmail('');
          setIsAdmin(false);
          return false;
        }
      } else {
        console.error('Invalid token format');
        localStorage.removeItem('token');
        setIsLoggedIn(false);
        setUserEmail('');
        setIsAdmin(false);
        return false;
      }
    } catch (error) {
      console.error('Error parsing token:', error);
      localStorage.removeItem('token');
      setIsLoggedIn(false);
      setUserEmail('');
      setIsAdmin(false);
      return false;
    }
  };

  useEffect(() => {
    // 检查本地存储中的 token
    const token = localStorage.getItem('token');
    if (token) {
      parseTokenAndSetUser(token);
    }
  }, []);

  const login = (token) => {
    localStorage.setItem('token', token);
    const success = parseTokenAndSetUser(token);
    
    if (!success) {
      setError('登录失败，请重新登录');
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    setUserEmail('');
    setIsAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, userEmail, isAdmin, login, logout, error }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}; 